export default __webpack_public_path__ + "98ca54752d0d98c2a0740c06dca15ded.png";